module.exports = __webpack_public_path__ + "img/butchery.7a6f0c47.png";